export default {
  name: 'Control Tower Management System',
  description: 'Enterprise Backend Management System',
  welcome: 'Welcome to'
}
